import React from 'react';
import { Grid, TextField, Autocomplete, Typography, Box, MenuItem } from '@mui/material';
import { procedureOptions, durationOptions } from '../../constants/options';

const ProcedureDetailsSection = ({ formData, handleChange, setFormData, errors }) => {
  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 'bold' }}>
        Step 2: Procedure Timings & Details
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
            <Autocomplete
                freeSolo
                options={procedureOptions}
                value={formData.name_of_procedure || ''}
                onChange={(_, newVal) => setFormData(prev => ({ ...prev, name_of_procedure: newVal }))}
                renderInput={(params) => (
                <TextField
                    {...params}
                    label="Name of Procedure"
                    required
                    fullWidth
                    InputLabelProps={{ sx: { '& .MuiFormLabel-asterisk': { color: 'red' } } }}
                    error={!!errors.name_of_procedure}
                    helperText={errors.name_of_procedure}
                />
                )}
            />
        </Grid>
        
        <Grid item xs={12} sm={4}>
            <TextField
                label="Operation Date"
                name="operation_date"
                type="date"
                value={formData.operation_date}
                fullWidth
                required
                InputLabelProps={{ shrink: true, sx: { '& .MuiFormLabel-asterisk': { color: 'red' } } }}
                onChange={handleChange}
                error={!!errors.operation_date}
                helperText={errors.operation_date}
            />
        </Grid>

        <Grid item xs={12} sm={4}>
            <TextField
                label="Start Time"
                name="operation_start_time"
                type="datetime-local"
                value={formData.operation_start_time}
                fullWidth
                required
                InputLabelProps={{ shrink: true, sx: { '& .MuiFormLabel-asterisk': { color: 'red' } } }}
                onChange={handleChange}
                error={!!errors.operation_start_time}
                helperText={errors.operation_start_time}
            />
        </Grid>

        <Grid item xs={12} sm={4}>
            <TextField
                select
                label="Duration"
                name="duration_of_procedure"
                value={formData.duration_of_procedure || ''}
                fullWidth
                required
                InputLabelProps={{ sx: { '& .MuiFormLabel-asterisk': { color: 'red' } } }}
                onChange={handleChange}
                error={!!errors.duration_of_procedure}
                helperText={errors.duration_of_procedure}
            >
                {durationOptions.map(opt => <MenuItem key={opt} value={opt}>{opt}</MenuItem>)}
            </TextField>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProcedureDetailsSection;
